import apiClient from '@/lib/apiClient';
import { z } from 'zod';

export const billingPeriodSchema = z.object({
    id: z.number(),
    label: z.string(),
    months: z.number(),
    discountPercent: z.number(),
    active: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string()
});

export type BillingPeriod = z.infer<typeof billingPeriodSchema>;

export const createBillingPeriodSchema = z.object({
    label: z.string(),
    months: z.number(),
    discountPercent: z.number(),
    active: z.boolean()
});

export type CreateBillingPeriod = z.infer<typeof createBillingPeriodSchema>;

export const getAllBillingPeriod = async () => {
    const data = await apiClient.get("/backoffice/billing-periods");
    const parsedData = z.array(billingPeriodSchema).safeParse(data);
    if(!parsedData.success) {
        throw new Error('Respuesta inválida al obtener períodos de facturación');
    }

    return parsedData.data;
}

export const createBillingPeriod = async (payload: CreateBillingPeriod) => {
    const data = await apiClient.post("/backoffice/billing-periods", payload);
    const parsedData = billingPeriodSchema.safeParse(data);
    if(!parsedData.success) {
        throw new Error('Respuesta inválida al crear período de facturación');
    }
    return parsedData.data;
}

export const updateBillingPeriod = async (payload: CreateBillingPeriod, payloadId: number) => {
    const data = await apiClient.put(`/backoffice/billing-periods/${payloadId}`, payload);
    const parsedData = billingPeriodSchema.safeParse(data);
    if(!parsedData.success) {
        throw new Error('Respuesta inválida al crear período de facturación');
    }
    return parsedData.data;
}

export const deleteBillingPeriod = async (payloadId: number) => {
    const data = await apiClient.delete(`/backoffice/billing-periods/${payloadId}`);
    const parsedData = z.object({message: z.string(), id: z.number()}).safeParse(data);
    if(!parsedData.success) {
        throw new Error('Respuesta inválida al crear período de facturación');
    }
    return parsedData.data;
}